'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var TextInput = require('../../TextInput-368d2d41.js');
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
require('@babel/runtime/helpers/slicedToArray');
require('../../SymbolsCounter.style-64b0606b.js');
var react = require('@emotion/react');
require('lodash/fp/fromPairs');
require('lodash/fp/map');
require('lodash/fp/toPairs');
require('lodash/fp/flow');
require('@babel/runtime/helpers/typeof');
require('../../Affix-535aba61.js');
require('../../Paragraph-284fa117.js');
require('@babel/runtime/helpers/taggedTemplateLiteral');
require('@emotion/styled');
require('../../parseDataAttributes-81c8dbee.js');
require('../../InputStatusIcon-f8340fe4.js');
require('../../useEventHandlers-fe0dbdf6.js');
require('../../useControllableStateAsEvent-37d110e1.js');
require('../../usePersistentCallback-d464e155.js');
require('../../getReactNode-625f4d64.js');
require('../Icon/icons/default/Warning.js');
require('../../withIconProps-365ff8d5.js');
require('@styled-system/should-forward-prop');
require('styled-system');
require('../Icon/icons/default/Tick.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);

var _excluded = ["type", "placeholder", "prefix", "suffix", "disabled", "value", "defaultValue", "onChange", "onFocus", "onBlur", "onKeyDown", "onKeyUp", "className", "validationStatus"];
var withLegacyProps = function withLegacyProps(Input) {
  return /*#__PURE__*/React.forwardRef(function (_ref, ref) {
    var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      placeholder = _ref.placeholder,
      prefix = _ref.prefix,
      suffix = _ref.suffix,
      disabled = _ref.disabled,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? function () {} : _ref$onFocus,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
      _ref$onKeyDown = _ref.onKeyDown,
      onKeyDown = _ref$onKeyDown === void 0 ? function () {} : _ref$onKeyDown,
      _ref$onKeyUp = _ref.onKeyUp,
      onKeyUp = _ref$onKeyUp === void 0 ? function () {} : _ref$onKeyUp,
      className = _ref.className,
      validationStatus = _ref.validationStatus,
      nativeProps = _objectWithoutProperties__default["default"](_ref, _excluded);
    var handleChange = function handleChange(event) {
      onChange(event.target.value, event);
    };
    var handleFocus = function handleFocus(event) {
      onFocus(event.target.value, event);
    };
    var handleBlur = function handleBlur(event) {
      onBlur(event.target.value, event);
    };
    var handleKeyDown = function handleKeyDown(event) {
      // @ts-expect-error TS2339: Property 'value' does not exist on type 'EventTarget'.
      onKeyDown(event.target.value, event);
    };
    var handleKeyUp = function handleKeyUp(event) {
      // @ts-expect-error TS2339: Property 'value' does not exist on type 'EventTarget'.
      onKeyUp(event.target.value, event);
    };
    return react.jsx(Input, _extends__default["default"]({}, nativeProps, {
      ref: ref,
      onChange: handleChange,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onKeyDown: handleKeyDown,
      onKeyUp: handleKeyUp,
      validationStatus: validationStatus,
      defaultValue: defaultValue,
      value: value,
      disabled: disabled,
      type: type,
      placeholder: placeholder,
      className: className,
      prefix: prefix,
      suffix: suffix
    }));
  });
};

exports.TextInput = TextInput.TextInput;
exports.withLegacyProps = withLegacyProps;
//# sourceMappingURL=index.js.map
